import moment from 'moment'
import DataManipulationUtils from '@/utils/DataManipulationUtils'

const SESSION_TOKEN_KEY = 'em_access_token'
const SESSION_EXP_KEY = 'em_exp'
const SESSION_EMAIL_KEY = 'em_email'
const SESSION_SUB_KEY = 'em_sub'
const CURRENT_ACCOUNT_KEY = 'em_current_account'
const MY_ACCOUNTS_KEY = 'em_my_accounts'

export default class LocalDataUtil {
  static setSession (session) {
    localStorage.setItem(SESSION_TOKEN_KEY, session.accessToken.jwtToken)
    localStorage.setItem(SESSION_EXP_KEY, session.accessToken.payload.exp)
    localStorage.setItem(SESSION_EMAIL_KEY, session.idToken.payload.email)
    localStorage.setItem(SESSION_SUB_KEY, session.idToken.payload.sub)
  }

  static removeSession () {
    localStorage.clear()
  }

  static getSession () {
    return localStorage.getItem(SESSION_TOKEN_KEY)
  }

  static getSub () {
    return localStorage.getItem(SESSION_SUB_KEY)
  }

  static setMyAccounts (list) {
    localStorage.setItem(MY_ACCOUNTS_KEY, JSON.stringify(list))
  }

  static getMyAccounts () {
    return JSON.parse(localStorage.getItem(MY_ACCOUNTS_KEY))
  }

  static setCurrentAccount (account) {
    localStorage.setItem(CURRENT_ACCOUNT_KEY, JSON.stringify(account))
  }

  static getCurrentAccount () {
    return JSON.parse(localStorage.getItem(CURRENT_ACCOUNT_KEY))
  }

  static getTimezone () {
    let myInfo = JSON.parse(localStorage.getItem(CURRENT_ACCOUNT_KEY))
    if (myInfo) {
      return myInfo.timezone
    }
    return null
  }

  static checkAccessToken () {
    const accessToken = localStorage.getItem(SESSION_TOKEN_KEY)
    if (accessToken) {
      if (DataManipulationUtils.decordJwtToken(accessToken).exp > moment().unix()) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}
